export enum SiteRisk {
  High = 'high',
  Inactive = 'inactive',
}
